import { render, staticRenderFns } from "./SummaCard.vue?vue&type=template&id=5929f2cf&scoped=true&"
import script from "./SummaCard.vue?vue&type=script&lang=js&"
export * from "./SummaCard.vue?vue&type=script&lang=js&"
import style0 from "./SummaCard.vue?vue&type=style&index=0&id=5929f2cf&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5929f2cf",
  null
  
)

export default component.exports